import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift, CheckCircle2 } from 'lucide-react';
interface WholesaleBonus {
  image: string;
  alt: string;
  badge: string;
  title: string;
  description: string;
  features: string[];
  value: string;
}
export function WholesaleBonuses() {
  const bonuses: WholesaleBonus[] = [{
    image: 'https://cdn.magicpatterns.com/uploads/mqMwJWhvtZTQkoi7y6Bt73/bono_1_wh.png',
    alt: 'Los 4 Softwares Fundamentales para Amazon Wholesale',
    badge: 'BONO PREMIUM #1',
    title: 'LOS 4 SOFTWARES FUNDAMENTALES PARA AMAZON WHOLESALE™',
    description: 'Aprende a utilizar Keepa, RevSeller, SmartScout y Seller Snap para analizar productos, validar rentabilidad y tomar mejores decisiones dentro de Amazon Wholesale.',
    features: ['Investigación avanzada de productos', 'Validación de rentabilidad', 'Análisis de competencia', 'Historial real de ventas', 'Herramientas utilizadas por vendedores profesionales'],
    value: '$37 USD'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/iYizVcZyRGFbiktoABT2j7/bono_2w.png',
    alt: 'Cómo hacer Online Arbitrage y Retail Arbitrage para Amazon',
    badge: 'BONO PREMIUM #2',
    title: 'CÓMO HACER ONLINE ARBITRAGE Y RETAIL ARBITRAGE PARA AMAZON™',
    description: 'Aprende a encontrar productos rentables en Walmart, Target, Ross, Marshalls y tiendas online para revender en Amazon paso a paso.',
    features: ['Cómo encontrar ofertas rentables', 'Cómo analizar productos correctamente', 'Cómo calcular ganancias reales', 'Cómo comprar con menor riesgo', 'Estrategias simples para comenzar rápido'],
    value: '$27 USD'
  }];
  return <section className="bg-brand-green py-24 px-6 relative overflow-hidden" data-id="element-900">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-901">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-902"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-beige rounded-full blur-3xl" data-id="element-903"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-904">
        {/* Header */}
        <FadeIn data-id="element-905">
          <div className="text-center mb-16" data-id="element-906">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6" data-id="element-907">
              <Gift className="w-8 h-8 text-brand-gold" data-id="element-908" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-909">
              🎁 BONOS PREMIUM INCLUIDOS
            </h2>
          </div>
        </FadeIn>

        {/* Bonus Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14 max-w-4xl mx-auto" data-id="element-910">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={0.15 * index} data-id="element-911">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden h-full flex flex-col hover:border-brand-gold/30 transition-colors" data-id="element-912">
                <div className="p-5 pb-0" data-id="element-913">
                  <img src={bonus.image} alt={bonus.alt} className="w-full h-auto rounded-xl object-contain" data-id="element-914" />
                </div>
                <div className="p-8 pt-5 flex flex-col flex-1" data-id="element-915">
                  <span className="inline-block w-fit text-xs font-bold tracking-wider text-brand-gold bg-brand-gold/10 border border-brand-gold/30 px-3 py-1 rounded-full mb-3" data-id="element-916">
                    {bonus.badge}
                  </span>
                  <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-917">
                    {bonus.title}
                  </h3>
                  <p className="text-white/50 text-sm md:text-base leading-relaxed mb-6" data-id="element-918">
                    {bonus.description}
                  </p>
                  <div className="space-y-3 mb-6" data-id="element-919">
                    {bonus.features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-920">
                        <CheckCircle2 className="w-4 h-4 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-921" />
                        <span className="text-sm text-white/80 font-medium" data-id="element-922">
                          {feature}
                        </span>
                      </div>)}
                  </div>
                  <div className="mt-auto pt-5 border-t border-white/10 flex items-center justify-between" data-id="element-923">
                    <span className="text-xs uppercase tracking-wider text-white/50 font-semibold" data-id="element-924">
                      VALOR OFICIAL
                    </span>
                    <span className="text-xl font-bold text-brand-gold" data-id="element-925">
                      {bonus.value}
                    </span>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}